export const raffleMixin = {
  computed: {
    canConfigureProducts() {
      return [
        'BY_SELECTED_ITEMS_QUANTITY',
        'BY_SELECTED_ITEMS_VALUE',
        'BY_COUPON_TOTAL_VALUE_PARTICIPANT_PRODUCT',
        'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT',
      ].includes(this.raffle.rules.type)
    },
    canConfigureProductGroups() {
      return this.raffle.rules.type === 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT_GROUPS_WITH_CUMULATIVE'
    },
  },
}
